import { useSelector } from 'react-redux';
import { adminRoleSelector } from 'ducks/user/selectors';

export const useAdminCheck = () => {
  const isAdmin = useSelector(adminRoleSelector);

  return isAdmin;
};
